import { Button, Typography } from '@mui/material';

import WarningIcon from '@mui/icons-material/WarningAmber';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';

import { ConflictList } from './ConflictList';
import { StyledTitle } from './ShiftInformation.styles';

export default function ConflictsDialog({ conflicts, handleClose, handleAssign, selectedEmployee }) {
  if (!conflicts.length) return null;

  return (
    <Dialog
      open={true}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <StyledTitle id="alert-dialog-title">
        <WarningIcon />
        Shift assignment warning
      </StyledTitle>
      <DialogContent>
        <Typography id="alert-dialog-description">
          {conflicts[0].type.includes('role')
            ? `${selectedEmployee.displayName} is not trained for this role.`
            : `${selectedEmployee.displayName} has availability conflicts with this shift:`}
        </Typography>
        <ConflictList conflicts={conflicts} />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleAssign}>Assign anyway</Button>
        <span>or</span>
        <Button onClick={handleClose} autoFocus>Cancel</Button>
      </DialogActions>
    </Dialog>
  );
}
